import { ClinicListingModel, IClinicListingModel } from "@common/models";
import { http } from "@common/utils";
import { trackPromise } from "react-promise-tracker";

export class ClinicListingService {
    private static baseUrl: string = '/api/cliniclist';

    public static tags = {
        getClinicListing: "getClinicListing"
    }


    static search = (clinicDate: string, marketId?: number, stateId?: number, storeName?: string, businessLineId?: number): Promise<ClinicListingModel[]> => {
        return trackPromise(new Promise<ClinicListingModel[]>((resolve, reject) => {
            http(`${this.baseUrl}?clinicDate=${clinicDate}&marketId=${marketId}&stateId=${stateId}&storeName=${storeName ? storeName : ""}&businessLineId=${businessLineId}`).get<IClinicListingModel[]>()
                .then((response) => response.map(mm => new ClinicListingModel(mm)))
                .then(resolve)
                .catch((err) => {
                    reject(err);
                });
        }), this.tags.getClinicListing);
    }
}
